<select [class]="formHelper.getValidIndicator(control())" [formControl]="control()" [id]="control().element.id">
  @for (option of control().element.options; track option.id) {
    <option [value]="option.id">{{ option.label }}</option>
  }
</select>
